import MVTImageryProvider from 'mvt-imagery-provider'

export default class MapboxLayer {

    /**
     * 
     * @param {Object} style
     */
    constructor(style) {
        this.mvtProvider = new MVTImageryProvider({
          style: style
        })
    }

    addTo(viewer) {
        this.imageryLayers = viewer.imageryLayers
        this.newLayer = this.imageryLayers.addImageryProvider(this.mvtProvider)
    }

    remove() {
        this.imageryLayers.remove(this.newLayer)
    }

    show() {
        this.imageryLayers.addImageryProvider(this.mvtProvider)
    }

    hide() {
        this.imageryLayers.remove(this.newLayer)
    }
}